var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-lg h-10 w-10 flex justify-center items-center"},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }